const scheduledSectionTimers = new WeakMap();

function updateScheduledSection(element) {
  if (window.Shopify?.designMode) {
    element.classList.remove('hidden');
    return;
  }

  const visible = isWithinSchedule(element);
  element.classList.toggle('hidden', !visible);

  if (!visible) {
    const timestamps = getScheduleTimestamps(element);
    if (timestamps && Date.now() >= timestamps.end) {
      const timerId = scheduledSectionTimers.get(element);
      if (timerId) {
        window.clearInterval(timerId);
        scheduledSectionTimers.delete(element);
      }
    }
  }
}

function initScheduledSections(root = document) {
  root.querySelectorAll('[data-scheduled-section]').forEach((element) => {
    if (scheduledSectionTimers.has(element)) return;

    updateScheduledSection(element);
    const timerId = window.setInterval(() => updateScheduledSection(element), 1000);
    scheduledSectionTimers.set(element, timerId);
  });
}

function bootScheduledSections() {
  initScheduledSections();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootScheduledSections);
} else {
  bootScheduledSections();
}

document.addEventListener('shopify:section:load', (event) => {
  initScheduledSections(event.target);
});
